import QuestionsList from "./pages/QuestionsList";

const QuestionsApp: React.FC = () => {       
    return (
      <QuestionsList />
    )
}
 
 export default QuestionsApp;